// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = theme => ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    width: 650,
    borderRadius: 15,
    [theme.breakpoints.down(700)]: {
      width: 550,
    },
    [theme.breakpoints.down(600)]: {
      width: '80%',
    },
    [theme.breakpoints.down(500)]: {
      width: '90%',
    },
  },
  modalTopContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    backgroundColor: GlobalStyles.color.COLOR_REJECT,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    padding: 10,
    position: 'relative',
  },
  modalImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 400,
    marginRight: 20,
    [theme.breakpoints.down(600)]: {
      marginBottom: 10,
    },
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxWidth: 250,
    gap: 10,
  },
  modalCloseIconContainer: {
    position: 'absolute',
    cursor: 'pointer',
    right: 10,
    top: 10,
  },
  modalCloseIcon: {
    width: 25,
    height: 25,
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'row',
    padding: 20,
    [theme.breakpoints.down(500)]: {
      flexDirection: 'column',
    },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(600)]: {
      marginLeft: 10,
    },
  },
  textContainer: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 10,
  },
  miniRegularText: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  boldFont: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  modalImage: {
    maxWidth: 250,
    maxHeight: 250,
    [theme.breakpoints.down(600)]: {
      marginRight: 0,
    },
  },
  rejectText: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    marginLeft: 3,
  },
  rejectionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
  },
  rejectionIcon: {
    maxHeight: 30,
  },
});

export default styles;
